export default "__VITE_ASSET__BfQQUjfO__"